// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".govip-text[data-v-8b100802] {\n  font-size: 24px;\n  color: #333;\n  margin-top: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 300px;\n}\n.gotoVip[data-v-8b100802] {\n  text-decoration: underline;\n  color: #39f;\n}", ""]);
// Exports
module.exports = exports;
